import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
export var Typography = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: var(--primary-font-family);\n    font-stretch: normal;\n    font-style: normal;\n    letter-spacing: normal;\n"])));
export default {
  Typography: Typography
};